// extracted by mini-css-extract-plugin
module.exports = {"content":"blogPost-module--content--7mJqX","meta":"blogPost-module--meta--RW8r3","featured":"blogPost-module--featured--2DXEW"};